
const state = {
    questionList: {},
    questionDetails: {},
    testTitle: {},
    knowledgeData: [],
    knowledgeCodes: [],
    homework: {},
    publishedData: [],
    files: {},
    isRefresh: true,
}
const getters = {

}
const mutations = {
    getQuestionList: function (state, _data) {
        if (Array.isArray(_data)) {
            let questionList = { FILL_BLANK: [], SINGLE_CHOICE: [], QUESTION_ANSWERING: [] }
            questionList.FILL_BLANK = _data.filter(
                item => item.type === "FILL_BLANK" // 填空题
            );
            questionList.SINGLE_CHOICE = _data.filter(
                item => item.type === "SINGLE_CHOICE" // 选择题
            );
            questionList.QUESTION_ANSWERING = _data.filter(
                item => item.type === "QUESTION_ANSWERING" // 解答题
            )
            return state.questionList = questionList

        } else {
            return state.questionList = _data
        }
    },
    deletleQuestion: function (state, params) {
        let type = params.type,
            id = params.id
        state.questionList[type] = state.questionList[type].filter(item => item.id !== id)
        return state.questionList

        // state.questionList.type.filter()
    },
    replaceQuestion: function (state, params) {
        let type = params.data.type,
            id = params.id
        state.questionList[type].map((item, index) => {
            if (item.id == id) {
                state.questionList[type].splice(index, 1, params.data)
            }
        })
        return state.questionLis
    },
    getQuestionDetails: function (state, params) {
        state.questionDetails = params.data;
        params.callBack()
    },
    getTestTitle: function (state, title) {
        state.testTitle = title;
    },
    addQuestion: function (state, params) {
        state.questionList[params.params.type].unshift(params.params)
        params.callBack(state.questionList)
    },
    getKnowledgeData: function (state, params) {
        state.knowledgeData = params.knowledgeData
        state.knowledgeCodes = params.knowledgeCodes
        params.callBack(state.questionList)
    },
    getHomework: function (state, params) {
        state.homework = params.data
        params.callBack()
    },
    getPublishedData: function (state, params) {
        state.publishedData = params.data
        params.callBack()
    },
    getFiles: function (state, params) {
        state.files = { ...params.list, name: params.name }
        params.callBack()
    },
    getIsRefresh: function (state, params) {
        state.isRefresh = params.isRefresh
        params.callBack()
    },
}
// actions,
// mutations
export default {
    state,
    getters, mutations

}



// WEBPACK FOOTER //
// ./src/store/modules/weeklySurvey.js